import { createContext, useContext, type ReactNode } from "react";

// Portaled controls share the same semantic colors as their owning surface.
export const darkSurfaceClasses = "[--background:#24272b] [--foreground:#f5f5f5] [--popover:#24272bf5] [--popover-foreground:#f5f5f5] [--muted:#ffffff12] [--muted-foreground:#c2c3c7] [--input:#ffffff26] [--border:#ffffff26] [--accent:#ffffff1c] [--accent-foreground:#fff] [--secondary:#ffffff12] [--secondary-foreground:#f5f5f5] [--primary:#f5f5f5] [--primary-foreground:#202225] [--ring:#d4d4d8] [color-scheme:dark]";
// Only redesigned surfaces opt into light/dark; ordinary pages keep default controls.
type SurfaceAppearance = "default" | "light" | "dark";
const SurfaceTheme = createContext<SurfaceAppearance>("default");

export function SurfaceThemeProvider({ appearance, children }: { appearance: SurfaceAppearance; children: ReactNode }) {
  return <SurfaceTheme.Provider value={appearance}>{children}</SurfaceTheme.Provider>;
}

export function useSurfaceTheme() { return useContext(SurfaceTheme); }

export function useSurfaceThemeClasses() {
  return useSurfaceTheme() === "dark" ? darkSurfaceClasses : undefined;
}
